import PropTypes from 'prop-types';

import {
    MenuItemType as SourceMenuItemType,
    MenuType
} from 'SourceType/Menu.type';

export {
    MenuType
};

export const MenuItemType = PropTypes.shape({
    ...SourceMenuItemType,
    is_promo: PropTypes.bool,
    promo_image: PropTypes.string,
    additional_menu: PropTypes.string,
    related_pages: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
        page_type: PropTypes.string,
        content_image_thumb: PropTypes.string,
        page_link_type_title: PropTypes.string
    })),
    is_new_products: PropTypes.bool,
    content_push: PropTypes.arrayOf(PropTypes.shape({
        supertitle: PropTypes.string,
        title: PropTypes.string,
        page_identifier: PropTypes.string,
        image_url: PropTypes.string,
        position: PropTypes.number
    }))
});
